import { getState, setState, putBookmarks } from '../core';
import { getContentId, setLocalBookmarks } from '../helpers';
import * as actions from '../actions';

export const removeBookmark = async (contentId = '') => {
  const { pageType } = getState();
  if (!['article', 'list'].includes(pageType!)) return;

  const contentIdToSend = contentId || getContentId(location.href);
  if (!contentIdToSend) {
    return actions.fail(false);
  }
  if (pageType === 'article') {
    //eagerly set state
    setState({ article: 'not-bookmarked', status: 'loading' });

    const response = await putBookmarks(contentIdToSend, false);
    const eventList = response.bookmarkEvents;
    setLocalBookmarks(eventList);
    setState({ status: 'idle' });
  }

  if (pageType === 'list') {
    // remove bookmark from view and send off to server. Only rerender when the list is empty.

    // store the action
    const response = await putBookmarks(contentIdToSend, false);
    const eventList = response.bookmarkEvents;
    setLocalBookmarks(eventList);

    const teaserToRemove = document
      .querySelector(`[data-action-remove="${contentIdToSend}"]`)
      ?.closest('.bookmark-teaser');

    const visibleTeasers = document.querySelectorAll('.bookmark-teaser');

    window.requestAnimationFrame(() =>
      teaserToRemove?.classList.toggle('removed', true)
    );

    if (!visibleTeasers.length) {
      setState({ eventList });
    }
  }
};
